class SopperFaq extends HTMLElement {
  connectedCallback() {
    this.addEventListener('click', this.handleClick);
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.handleClick);
  }

  handleClick = (event) => {
    const selected = event.target.closest('button[aria-controls]');
    if (!selected || !this.contains(selected)) return;
    const shouldOpen = selected.getAttribute('aria-expanded') !== 'true';
    for (const button of this.querySelectorAll('button[aria-controls]')) {
      const open = button === selected && shouldOpen;
      const answer = document.getElementById(button.getAttribute('aria-controls'));
      button.setAttribute('aria-expanded', String(open));
      if (answer) answer.hidden = !open;
    }
  };
}

if (!customElements.get('sopper-faq')) customElements.define('sopper-faq', SopperFaq);
